// services/contactCommentService.ts

import apiClient from "../../core/apiClient";
import { ContactComment } from "../../interfaces/DTO/crm/contactComment";
import { BaseService } from "../BaseService";



const API_URL = "/contact-comments";

class ContactCommentService extends BaseService<ContactComment> {
  constructor() {
    super(API_URL);
  }
  async getByContactId(contactId: number): Promise<ContactComment[]> {
    if (!contactId) return [];
    const response = await apiClient.get<ContactComment[]>(`${this.baseUrl}/contact/${contactId}`);
    return response.data;
  }
  // כאן ניתן להוסיף פעולות מותאמות אישית בעתיד
}

export const contactCommentService = new ContactCommentService();
